import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore"; // Import Firestore functions
import { db } from "../../firebaseConfig"; // Import your Firebase configuration
import "./MastersForm.css"; // Optional for styling

const MastersForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    credentials: "",
    description: "",
    longDescription: "",
    photo: "",
    programs: "",
    events: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Prepare data
    const newMaster = {
      ...formData,
      programs: formData.programs.split(",").map((p) => p.trim()), // Convert comma-separated string to array
      events: formData.events.split(",").map((e) => e.trim()), // Convert comma-separated string to array
    };

    try {
      const docRef = await addDoc(collection(db, "Masters"), newMaster);
      console.log("Document written with ID: ", docRef.id);

      // Reset form
      setFormData({
        name: "",
        surname: "",
        credentials: "",
        description: "",
        longDescription: "",
        photo: "",
        programs: "",
        events: "",
      });
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  return (
    <div className="masters-form-container">
      <h1>Add a New Master</h1>
      <form onSubmit={handleSubmit} className="masters-form">
        <label>
          Name:
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Surname:
          <input
            type="text"
            name="surname"
            value={formData.surname}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Credentials:
          <input
            type="text"
            name="credentials"
            value={formData.credentials}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Description:
          <input
            type="text"
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Long Description:
          <textarea
            name="longDescription"
            value={formData.longDescription}
            onChange={handleChange}
            required
          ></textarea>
        </label>
        <label>
          Photo URL:
          <input
            type="text"
            name="photo"
            value={formData.photo}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Programs (comma-separated):
          <input
            type="text"
            name="programs"
            value={formData.programs}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Events (comma-separated):
          <input
            type="text"
            name="events"
            value={formData.events}
            onChange={handleChange}
            required
          />
        </label>
        <button type="submit">Add</button>
      </form>
    </div>
  );
};

export default MastersForm;
